module.exports = __webpack_public_path__ + "static/media/21.542c7dde.jpg";